export const cmeTypes = ['mentions', 'tdos', 'watchlists', 'collections'];

export const appPackageComponentTypes = [
  {
    type: 'engine',
    label: 'Engine',
    group: 'engines'
  },
  {
    type: 'dataSchema',
    label: 'Data Schema',
    group: 'dataRegistries'
  },
  {
    type: 'contextMenuExtension',
    label: 'Context Menu Extension',
    group: 'contextMenuExtensions'
  },
  {
    type: 'oauth2RedirectUrl',
    label: 'OAuth2 URL',
    group: 'oauth2RedirectUrls'
  },
  {
    type: 'appSwitcherShortcut',
    label: 'App Switcher Shortcut',
    group: 'appSwitcherShortcuts'
  }
];



// WEBPACK FOOTER //
// ./src/client/modules/application/constants.js